// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__34z0y","imageUploader":"EGiftCard_imageUploader__38u_Z"};